export default {
  namespaced: true,
  state: {
    mini: true,
    itemsMenu: [
      { icon: 'fas fa-file-signature', title: 'PROPOSTAS', to: '/propostas' },
      {
        icon: 'fas fa-file-invoice-dollar',
        title: 'NOTAS FISCAIS',
        to: '/notas-fiscais',
      },
      {
        svg: 'factCheckIcon',
        title: 'CONSULTA DE SALDO',
        to: '/consulta-de-saldo',
      },
    ],
  },
  mutations: {
    OPEN_CLOSE_MENU(state) {
      state.mini = !state.mini;
    },
  },
  actions: {
    openCloseMenu({ commit }) {
      commit('OPEN_CLOSE_MENU');
    },
  },
};
